import { create } from "zustand";
import { dashboardTabs } from "@app/config/tabs";

export type UiState = {
  activeTab: string;
  setActiveTab: (tabId: string) => void;
  activeGroup: string;
  setActiveGroup: (groupId: string) => void;
};

export const useUiStore = create<UiState>((set, get) => {
  const storedTab =
    typeof window !== "undefined" ? window.localStorage.getItem("activeTab") : null;

  const storedGroup =
    typeof window !== "undefined" ? window.localStorage.getItem("activeGroup") : null;

  const initTab = storedTab ?? "trading-logic-controls";

  const initGroup = storedGroup ?? (() => {
    const tab = dashboardTabs.find((t) => t.id === initTab);
    return tab?.group ?? "trading-controls";
  })();

  return {
    activeTab: initTab,
    activeGroup: initGroup,

    setActiveTab: (tabId) => {
      if (typeof window !== "undefined") {
        window.localStorage.setItem("activeTab", tabId);
      }
      const tab = dashboardTabs.find((t) => t.id === tabId);
      const groupId = tab?.group ?? get().activeGroup;
      if (typeof window !== "undefined") {
        window.localStorage.setItem("activeGroup", groupId);
      }
      set({ activeTab: tabId, activeGroup: groupId });
    },

    setActiveGroup: (groupId) => {
      if (typeof window !== "undefined") {
        window.localStorage.setItem("activeGroup", groupId);
      }
      const firstTabInGroup = dashboardTabs.find((t) => t.group === groupId);
      const newTabId = firstTabInGroup?.id ?? get().activeTab;
      if (typeof window !== "undefined") {
        window.localStorage.setItem("activeTab", newTabId);
      }
      set({ activeGroup: groupId, activeTab: newTabId });
    },
  };
});
